// Generated by ReScript, PLEASE EDIT WITH CARE


var initial_state = {
  base_details: undefined,
  slab_details: undefined
};

export {
  initial_state ,
  
}
/* No side effect */
